import { useCallback } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useKeyPress, useSetState } from 'ahooks'
import { Button, Modal } from 'components/Share'
import * as config from 'config'

interface State {
  showVersion: boolean
}

const AppVersion = (): JSX.Element => {
  const { t } = useTranslation()
  const [state, setState] = useSetState<State>({
    showVersion: false,
  })

  useKeyPress('ctrl.alt.v', () => {
    setState({ showVersion: true })
  })

  const closeVersionModal = useCallback(() => {
    setState({ showVersion: false })
  }, [setState])

  return (
    <>
      <Modal
        show={state.showVersion}
        title="Version"
        body={<>{config.appVersion}</>}
        footer={
          <>
            <Button
              text={String(t('share.close'))}
              handleClick={closeVersionModal}
            />
          </>
        }
      />
    </>
  )
}

export default AppVersion
